type BreadcrumbData = Record<string, unknown>

function addTelemetryBreadcrumb(category: string, message: string, data?: BreadcrumbData) {
  if (import.meta.env.DEV) {
    console.debug(`[telemetry] ${category}: ${message}`, data ?? {})
  }
}

export function trackDigestToggle(channel: string, enabled: boolean) {
  addTelemetryBreadcrumb("digest_toggle", "notifications.channel", {
    channel,
    enabled,
  })
}

export function trackDegradedRails(rails: string[], location: string) {
  if (!rails.length) return
  addTelemetryBreadcrumb("degraded_state", "degraded.banner", {
    rails,
    location,
  })
}

export function trackOnboardingEvent(event: string, data?: BreadcrumbData) {
  addTelemetryBreadcrumb("onboarding", event, data)
}
